const isBrowser = typeof window !== 'undefined' && window !== null;
let L;

if (isBrowser) {
    L = require('leaflet');
}

export function createWmtsLayer(url, options) {


  if (!L.TileLayer.WMTS) {
    L.TileLayer.WMTS = L.TileLayer.extend({
      defaultWmtsParams: {
        service: 'WMTS',
        request: 'GetTile',
        version: '1.0.0',
        layer: '',
        style: null,
        tilematrixSet: '',
        format: 'image/png'
      },

      initialize: function (url, options = {}) {
        this._url = url;

        const wmtsParams = { ...this.defaultWmtsParams };
        for (const key in options) {
          if (!(key in this.options)) {
            wmtsParams[key] = options[key];
          }
        }

        this.wmtsParams = wmtsParams;
        L.setOptions(this, options);
      },

      getTileUrl: function (coords) {
        const tileMatrix = this._tileZoom;
        const tileCol = coords.x;
        const tileRow = coords.y;

        if  (this.wmtsParams.style) {
            return (
                `${this._url}${this.wmtsParams.layer}/${this.wmtsParams.style}/${this.wmtsParams.tilematrixSet}/` +
                `${tileMatrix}/${tileCol}/${tileRow}.png`
              );
        }

        return (
          `${this._url}${this.wmtsParams.layer}/${this.wmtsParams.tilematrixSet}/` +
          `${tileMatrix}/${tileCol}/${tileRow}.png`
        );
      }
    });
  }

  return new L.TileLayer.WMTS(url, options);
}



// WEBPACK FOOTER //
// src/components/utils/wmtsLayer.js